package it.neckar.lizergy.comments.lifecycle

/**
 * Lizergy-local copy of the former Commons `HasLifeCycle` interface. See [LifeCycleState] for the
 * reason why Lizergy carries its own duplicate.
 */
interface HasLifeCycle {
  val lifeCycleState: LifeCycleState

  fun isActive(): Boolean {
    return lifeCycleState.isActive()
  }

  fun isNotEndOfLife(): Boolean {
    return lifeCycleState.isNotEndOfLife()
  }

  fun isEndOfLife(): Boolean {
    return lifeCycleState.isEndOfLife()
  }
}

fun <T : HasLifeCycle> List<T>.onlyActive(): List<T> {
  return only(LifeCycleState::isNotEndOfLife)
}

fun <T : HasLifeCycle> List<T>.only(selector: ((LifeCycleState) -> Boolean)?): List<T> {
  if (selector == null) return this

  return this.filter {
    selector(it.lifeCycleState)
  }
}
